import { useTranslation } from 'react-i18next'
import { ToggleFormField } from '../../../../../../../common/components/Form/ToggleFormField/ToggleFormField'
import { PointsInput } from '../../../../Points/PointsInput'
import { PointsInputPreview } from '../../../../Points/PointsPreview'
import styles from './AllAnswersSamePoints.module.css'
import { useForm, useField } from 'react-final-form'

type TotalPointsProps = {
  name: string
  isChecked?: boolean
  viewOnly: boolean
  points?: number
}

export const TotalPoints: React.FC<TotalPointsProps> = ({ name, isChecked: _isChecked, viewOnly, points }) => {
  const { t } = useTranslation()
  const form = useForm()

  const hasTotalPointsField = useField<boolean>(`${name}.data.hasTotalPoints`, { subscription: { value: true } })
  const hasTotalPoints = !!hasTotalPointsField.input.value

  return (
    <div className={styles.allAnswersPointsContainer}>
      <ToggleFormField
        name={`${name}.data.hasTotalPoints`}
        label={t('game_editor.tasks.answer_options.total_points_label', 'Limit maximum amount of points')}
        description={t(
          'game_editor.tasks.answer_options.total_points_description_disabled',
          'Set a fixed amount of points that can be awarded for completing the task',
        )}
        descriptionChecked={t(
          'game_editor.tasks.answer_options.total_points_description_enabled',
          'Set a fixed amount of points that can be awarded for completing the task',
        )}
        disabled={viewOnly}
        onChange={(nextChecked) => {
          form.batch(() => {
            // Set this toggle's value
            form.change(`${name}.data.hasTotalPoints`, !!nextChecked)
            // Turning ON total points → disable same-points and clear its numeric
            if (nextChecked) {
              form.change(`${name}.data.allAnswersHaveSamePoints`, false)
              form.change(`${name}.data.allAnswersPoints`, undefined)
            } else {
              // Turning OFF total points → clear its numeric so backend doesn't infer it back
              form.change(`${name}.data.totalPoints`, 0)
            }
          })
        }}
      />
      <div>
        {hasTotalPoints ? (
          <PointsInput name={`${name}.data.totalPoints`} disabled={viewOnly} />
        ) : (
          <PointsInputPreview disabled />
        )}
      </div>
    </div>
  )
}
